import {debounce} from 'lodash';
import {Map} from 'immutable';
import moment from 'moment-timezone';
import createAssignmentActions from '../CreateAssignment.actions';
import {callAction} from 'client/framework';

const formatDate = (date, time) => {
  const formattedTime = moment(time, 'h:mm A').format('HH:mm:ss');
  return moment(`${date} ${formattedTime}`).valueOf();
};

const handleInputChange = (name, value, type) => {
  const inputState = new Map({
    key: name,
    value: type === 'number' ? parseInt(value, 10) : value
  });
  callAction(createAssignmentActions.SET_FIELD_STATE, inputState);
  callAction(createAssignmentActions.VALIDATE_ASSIGNMENT);
};

const debouncedHandleInputChange = debounce(handleInputChange, 300);

const timezoneString = moment()
  .tz(moment.tz.guess())
  .format('z');

const confirmChangesRules = {
  due_date: (oldAssignment, newAssignment) => {
    if (
      newAssignment.existsOnServer() &&
      newAssignment.getDueDate().isBefore(oldAssignment.getDueDate())
    ) {
      return 'Choosing a due date prior to the original may cause some students to be marked "Submitted late", even if they submitted the assignment on time according to the previous due date.';
    }
    return null;
  }
};

export {
  confirmChangesRules,
  debouncedHandleInputChange,
  formatDate,
  handleInputChange,
  timezoneString
};
